import React from "react";
const cx = require('classnames')

const Table = ({children}: any) =>
  <table className="table table-sm table-striped table-hover">
    {children}
  </table>

export const Grid = ({ children, ...rest }: any) => (
  <Table {...rest}>
    <tbody>{children}</tbody>
  </Table>
);

export const Row = ({ children, sizes = [], separator = false } : { sizes?: number[], separator? : boolean, children: any}) => {
  const content = () => {
    return React.Children.map(children, (child, index) =>
      React.cloneElement(child, { _size: sizes[index] })
    );
  };
  return <tr className={cx({"row-separator": separator})}>{ content() }</tr>;
};

export const Cell = ({align = "left", span, children} : { align?: "left" | "right" | "center", span?: number, children?: any}) =>
  <td style={{textAlign: align}} colSpan={span || 1}>
    {children}
  </td>

export const CellIndent = ({ level, children }: { level: 1 | 2 | 3 | 4, children?: any}) =>
  <span style={{padding: `0 0 0 ${level}em`}}>{children}</span>